module.exports = __webpack_public_path__ + "static/mlh-logo-color-9389d3622729651df7e6a2c93b27bb1b.png";